<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-部门-修改
    -->
    <el-dialog
    title="修改部门"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form 
        ref="formRef" 
        :model="form" 
        :rules="rules" 
        label-width="100px"
        size="small"
      >
        <el-form-item label="上级部门" prop="parent_id">
          <el-cascader
            v-model="form.parent_id"
            :options="departmentTree"
            :props="{ 
              value: 'ma_depart_id', 
              label: 'name', 
              children: 'children',
              checkStrictly: true,
              emitPath: false
            }"
            clearable
            style="width: 100%;"
            placeholder="请选择上级部门（不选则为顶级部门）"
          ></el-cascader>
        </el-form-item>
        
        <el-form-item label="部门名称" prop="name">
          <el-input 
            v-model="form.name" 
            placeholder="请输入部门名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        
        <el-form-item label="部门职能" prop="remark">
          <el-input 
            v-model="form.remark" 
            type="textarea"
                  :rows="16"
            placeholder="请输入部门职能描述"
            maxlength="3000"
            show-word-limit
          ></el-input>
        </el-form-item>
        

    

        <el-form-item label="是否隐藏" prop="is_hide">
          <el-switch
            v-model="form.is_hide"
            :active-value="1"
            :inactive-value="0"
            active-text="隐藏"
            inactive-text="显示"
          ></el-switch>
        </el-form-item>

        <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
      </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>

import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
        image:[],
        sort:50,
        intro:"",
        bannar:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",

         departmentTree:[]
    };
  },
  created() {
    console.log(11111)
     this.getDepartmentTree();
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","ma_depart_id"],
  methods: {
      // 获取部门树形数据
      async getDepartmentTree() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.buildDepartmentTree(response.data.list.data || []);
        }
      } catch (error) {
        console.error('获取部门树失败:', error);
      }
    },
    
    // 构建部门树形结构
    buildDepartmentTree(departments) {
      const tree = [];
      const map = {};
      
      // 创建映射
      departments.forEach(dept => {
        map[dept.ma_depart_id] = { ...dept, children: [] };
      });
      
      // 构建树
      departments.forEach(dept => {
        const node = map[dept.ma_depart_id];
        if (dept.parent_id === 0) {
          tree.push(node);
        } else if (map[dept.parent_id]) {
          map[dept.parent_id].children.push(node);
        }
      });
      
      this.departmentTree = tree;
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    async getDetail() {
      let self = this;
      // 取到路由带过来的参数
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'detail',
          ma_depart_id: self.ma_depart_id
        });
          if (response.code === 1) {
           self.form= response.data;
        }
    },
   async onSubmit() {
      let self = this;
      let form = self.form;
      form.ma_depart_id = self.ma_depart_id;
       self.loading = true;
       const formData = {
            model: 'ma_depart',
            ...this.form,
          };

       const response = await AfuncApi.call({
              ...formData,
              action: 'edit'
            });
        if (response.code === 1) {
            this.$message.success('修改成功');
             self.dialogFormVisible("error")
      
        }
    
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_depart/index/part/edit.vue